var els = {
    // Form Element
    elForm: () => $("#product-form"), // Hidden elements
    hdnVariantId: () => $("#hdnAttrVariantId"),
    hdnType: () => $("#hdnAttrType"),
    hdnMake: () => $("#hdnAttrMake"),
    hdnModel: () => $("#hdnAttrModel"),
    hdnImage: () => $("#hdnAttrImage"),
    hdnImageCropped: () => $("#hdnAttrImageCropped"),
    hdnIndexId: () => $("#hdnAttrIndexId"),
    btnTriggerEdit: () => $("#btnTriggerEdit"),
    btnTriggerColor: () => $("#btnTriggerColor"),
    btnTriggerAddText: () => $("#btnTriggerAddText"),
    btnTriggerSave: () => $("#btnSave"), // Text
    modalPopUpText: () => $("#custom-text-modal"),
    modalTextColorWrapper: () => els.modalPopUpText().find(".wrapper-color"),
    modalTextFontWrapper: () => els.modalPopUpText().find(".wrapper-font"),
    txtPopUpText: () => $("#elTextArea"),
    btnTextModalAdd: () => $("#btnTextModalAdd"),
    btnTextModalUpdate: () => $("#btnTextModalUpdate"),
    modalPopUpBackground: () => $("#custom-color-modal"),
    btnCloseColorModal: () => els.modalPopUpBackground().find(".close"),
    modalBackgroundColorWrapper: () => els.modalPopUpBackground().find(".bg-color-trigger-wrapper"),
    btnTextModalApply: () => $("#btnTextModalApply"), // Dev elements
    btnDevDisplay: () => $("#btnDevDisplay"),
    btnDevCropped: () => $("#btnDevCropped"),
    btnDevOriginal: () => $("#btnDevOriginal"),
    btnDevUpload: () => $("#btnDevUpload"),
};
function fetchApiUrl(apiUrl) {

        return fetch(apiUrl)
            .then(response => response.json()).then(data => {
                return data;
            })
            .catch(error => {
                console.error(error);
            });
    }

function openCart() {
    const cartElementRef = document.getElementsByTagName('cart-drawer')[0];
    cartElementRef.classList.add('active');
}

const fbrBackgroundColor = {
    _previousColor: null,
    _colors: ["#aaaaaa", "#FF2B3A", "#FF5300", "#FFBE0B", "#FF006E", "#8338EC", "#3A86FF", "#75FAFF", "#00FFE7", "#8EB719",
        "#1A759F", "#BC6C25", "#606C38", "#FFF500", "#A0077C", "#172C85", "#EE7ADF", "#D9ED92","#000000",
        "#FFFFFF"],

    InitializeEvents: function () {
        els.btnTriggerColor().on("click", (e) => {
            fbrBackgroundColor.OpenColorModal();
        });
    },
    OpenColorModal: function (){
        let activeBgColor = fbrCanvas.obj.backgroundColor;
        const bgColorButtons = fbrBackgroundColor._colors.map((colorItem) => {
            const isActive = activeBgColor === colorItem ? 'active' : '';
            return `<div class="bg-color-trigger ${isActive}" data-color="${colorItem}" onclick="fbrBackgroundColor.ChooseColor(this)"
                        style="background-color: ${colorItem}" ></div>`;
        }).join('');

        let bgColorModal = `<div class="myx-body" id="custom-modal-body">
              <div class="bg-color-trigger-wrapper">${bgColorButtons}</div>
            </div>
            <div class="myx-footer-modal-btn" ">
              <button id="btnTextModalApply" class="personalize-btn apply-btn" onclick="fbrBackgroundColor.ApplyColor()" >Apply</button>
            </div>`;
        openModelContainer(bgColorModal, 'customization', "Background color", true);
    },
    ChooseColor: function(e) {
        $('.bg-color-trigger').removeClass('active');
        $(e).addClass("active");
    },
    ApplyColor: function () {
        const selectedColorEl = $('.bg-color-trigger.active');

        if (selectedColorEl.length > 0) {
            fbrCanvas.obj.backgroundColor = selectedColorEl.data('color');
            fbrCanvas.obj.requestRenderAll();
        }
        hideAndResetModal();
    }
};

const fbrText = {
    defaultParams: {
        lockUniScaling: true,
        centeredScaling: true,
        cornerColor: "lime",
        cornerStyle: 'circle',
        transparentCorners: false,
        lockScalingFlip: true,
        lockSkewingX: true,
        lockSkewingY: true,
        crossOrigin: "anonymous"
    },
    _currentEditingObject: null,
    _colors: ['rgb(0,0,0)', 'rgb(255,0,0)', 'rgb(255,153,0)', 'rgb(97,255,0)', 'rgb(0,255,240)', '#0066FF', '#FF00B8', '#AD00FF', 'rgb(255,255,255)'],
    _fonts: ['Lobster', 'Abril_Fatface', 'Amatic_SC', 'Black_Ops_One', 'Bungee', 'Gloria_Hallelujah', 'Rye', 'Shadows_Into_Light', 'Love_Ya_Like_A_Sister'],
    _canvasObj() {
        return fbrCanvas.obj;
    },
    InitializeEvents() {
        els.btnTriggerAddText().on("click", () => {
            fbrText.InitializeModal(null, true);
        });
    },
    InitializeModal(data, isToOpen = false) {
        fbrText._currentEditingObject = data;
        const activeFont = data?.fontFamily?.replaceAll(" ", "_") || fbrText._fonts[0];
        const activeColor = data?.fill || fbrText._colors[0];
        const activeText = data?.text || '';
        let activeFontClass = '';
        const fontButtons = fbrText._fonts.map((fontClass) => {
            const isActive = fontClass === activeFont ? 'active' : '';
            activeFontClass = isActive ? `font-${fontClass}` : activeFontClass;
            return `<button class="btn-font-trigger font-${fontClass} ${isActive}" data-font="${fontClass}" onclick="fbrText.ChangeTextFont(this)">Style</button>`;
        }).join('');

        const colorButtons = fbrText._colors.map((colorItem) => {
            const isActive = colorItem === activeColor ? 'active' : '';
            return `<div class="btn-color-trigger ${isActive}" data-color="${colorItem}" style="background-color: ${colorItem}" onclick="fbrText.ChangeTextColor(this)"></div>`;
        }).join('');

        const textModalBody = `
            <div class="text-modal-body">
              <!-- Text area element -->
              <textarea class="custom-text-content ${activeFontClass}" id="elTextArea" rows="3" data-font="${activeFont}" data-color="${activeColor}" style="color: ${activeColor}">${activeText}</textarea>
              <!-- Font button trigger -->
              <div class="btn-font-trigger-wrapper wrapper-font">
                ${fontButtons}
              </div>
              <!-- Color button trigger -->
              <div class="btn-color-trigger-wrapper wrapper-color">
                ${colorButtons}
              </div>
            </div>
            <div class="myx-footer-modal-btn" >
              <button id="btnTextModalUpdate" class="personalize-btn apply-btn" onclick="fbrText.updateText()">Update</button>
            </div>
            `;

        openModelContainer(textModalBody, 'customization', "Text", true);
    },
    updateText() {
        const txtEl = els.txtPopUpText();
        const txt = txtEl.val();
        const color = txtEl.attr("data-color");
        const family = txtEl.attr("data-font").replace(/_/g, " ");
        if (fbrText._currentEditingObject) {
            // Update existing text object
            fbrText._currentEditingObject.text = txt;
            fbrText._currentEditingObject.set("fill", color);
            fbrText._currentEditingObject.fontFamily = family;
            fbrCanvas.obj.requestRenderAll();
        } else {
            // Add new text object
            const txtObj = new fabric.Text(txt, fbrText.defaultParams);
            txtObj.fill = color;
            txtObj.fontFamily = family;
            txtObj.setControlsVisibility({
                ml: false,
                mt: false,
                mr: false,
                mb: false,
            });
            fbrText._canvasObj().add(txtObj);
            fbrText._canvasObj().centerObject(txtObj);
            fbrCanvas.obj.requestRenderAll();
        }
        hideAndResetModal();

    },
    ChangeTextFont(e) {
        $(".btn-font-trigger").removeClass("active");
        $(e).addClass("active");
        let clsLst = els.txtPopUpText()[0].classList.value.split(" ");
        for (let i = 0; i < clsLst.length; i++) {
            if (clsLst[i].indexOf("font") === 0) {
                els.txtPopUpText().removeClass(clsLst[i]);
            }
        }
        els.txtPopUpText().addClass(`font-${$(e).data('font')}`);
        els.txtPopUpText().attr('data-font', $(e).data('font'));
    },
    ChangeTextColor(e) {
        $(".btn-color-trigger").removeClass("active");
        $(e).addClass("active");
        els.txtPopUpText().css('color', $(e).data('color'));
        els.txtPopUpText().attr('data-color', $(e).data('color'));
    }
};

const fbrImage = {
    _overlayImageURL: 'https://w0uhs35fj2.execute-api.ap-south-1.amazonaws.com/default/myxt-template-img',
    defaultParams: {
        lockUniScaling: true,
        centeredScaling: true,
        cornerColor: "lime",
        cornerStyle: 'circle',
        transparentCorners: false,
        lockScalingFlip: true,
        lockSkewingX: true,
        lockSkewingY: true,
        crossOrigin: "anonymous"
    },
    _canvasObj: function () {
        return fbrCanvas.obj;
    },
    InitializeEvents: function () {
        document.getElementById("btnTriggerImage").addEventListener("click", () => {
            document.getElementById("inputFile").click();
        });
        document.getElementById("inputFile").addEventListener("change", (ev) => {
            const obj = document.getElementById("inputFile");
            let fileReader = new FileReader();
            fileReader.addEventListener("load", (e) => {
                fbrImage.AddImage(e.target.result);
            }, true);
            fileReader.readAsDataURL(obj.files[0]);
            obj.value = null;
        });
    },
    SetOverlayImage: async function (imgURL) {
        let urlComponents = imgURL.split('/');
        let dir = urlComponents[urlComponents.length - 2];
        let file = urlComponents[urlComponents.length - 1];

        let imageURL = `${fbrImage._overlayImageURL}?dir=${dir}&file=${file}`;
        let imgData = await fetch(imageURL)
            .then((response) => response.json());

        fabric.Image.fromURL('data:image/png;base64,' + imgData.data, (img) => {
            img.scaleToHeight(page.height);
            fbrImage._canvasObj().setOverlayImage(img);
            fbrImage._canvasObj().requestRenderAll();
        }, fbrImage.defaultParams);
    },
    AddImage: function (imgURL) {
        fabric.Image.fromURL(imgURL, (img) => {
            let imgRatio = img.width / img.height;
            if (imgRatio >= page.ratio) {
                img.scaleToWidth(page.width);
            } else {
                img.scaleToHeight(page.height);
            }
            const imgCount = fbrCanvas.obj._objects.filter(x => x._element).length;
            img.setControlsVisibility({ml: false, mt: false, mr: false, mb: false,});
            fbrImage._canvasObj().add(img);
            fbrImage._canvasObj().centerObject(img);
            img.moveTo(imgCount);
            fbrCanvas.obj.requestRenderAll();
        }, fbrImage.defaultParams);
    },
    AddDesignImage: function (imgURL) {
        fabric.Image.fromURL(imgURL, (img) => {
            let imgRatio = img.width / img.height;
            if (imgRatio >= page.ratio) {
                img.scaleToWidth(page.width);
            } else {
                img.scaleToHeight(page.height);
            }
            fbrImage._canvasObj().setBackgroundImage(img);
            fbrCanvas.obj.requestRenderAll();
        }, fbrImage.defaultParams);
    }
};

const fbrCanvas = {
    id: 'fbrCanvasElement',
    obj: null,
    maskURL: null,
    desinImgUrl: null,
    desinImgHandle: null,
    defaultCanvasParams: {
        preserveObjectStacking: true,
        centeredScaling: true,
        enableRetinaScaling: true,
        transparentCorners: false,
        selection: false,
        backgroundColor: '#aaaaaa',
    },
    Init: function () {
        fbrCanvas.Initialize();
        fbrCanvas.InitializeEvents();
    },
    Initialize: function () {
        let canvasEl = new fabric.Canvas(fbrCanvas.id, fbrCanvas.defaultCanvasParams);
        fbrCanvas.obj = canvasEl;
        fbrCanvas.obj.setDimensions({width: page.width, height: page.height});
        fbrCanvas.UpdateOverlayImage();
        fbrCanvas.obj.requestRenderAll();
        fbrCanvas.UpdateDesignImage();
    },
    InitializeEvents: function () {
        if (!fbrCanvas.obj) {
            fbrCanvas.Initialize();
        }
        fbrCanvas.obj.on("selection:created", () => {
            $(".wrapper-warning-messages").css('visibility', 'visible');
            fbrCanvas.ToggleOverlayOpacity(false);
        });
        fbrCanvas.obj.on("selection:updated", () => {
            $(".wrapper-warning-messages").css('visibility', 'visible');
            fbrCanvas.ToggleOverlayOpacity(false);
        });
        fbrCanvas.obj.on("selection:cleared", () => {
            $(".wrapper-warning-messages").css('visibility', 'hidden');
            fbrCanvas.ToggleOverlayOpacity(true);
        });
        fbrCanvas.obj.on("mouse:wheel", (e, x) => {
            let activeObj = fbrCanvas.obj.getActiveObject();
            if (activeObj != null) {
                let scaleVal = activeObj.scaleX;
                let ds = e.e.deltaY >= 0 ? -0.01 : 0.01;
                activeObj.scaleX = activeObj.scaleY = scaleVal + ds;
                fbrCanvas.obj.requestRenderAll();

            }
        });

        els.btnTriggerEdit().on("click", (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            fbrCanvas.EventEdit();
        });
        $("#btnTriggerDelete").on("click", (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            fbrCanvas.EventDelete();
        });
    },
    UpdateOverlayImage: function () {
        if (!fbrCanvas.obj || !fbrCanvas.maskURL) {
            return;
        }
        fbrImage.SetOverlayImage(fbrCanvas.maskURL);
    },
    EventEdit: function () {
        const activeObj = fbrCanvas.GetActiveObject();
        if (activeObj.type === 'text') {
            fbrText.InitializeModal(activeObj, true);
        }
    },
    EventDelete: function () {
        fbrCanvas.RemoveActiveItem();
    },
    GetActiveObject: function () {
        let $obj = fbrCanvas.obj;
        if (!$obj || !$obj._activeObject) return null;

        return $obj._activeObject;
    },
    RemoveActiveItem: function () {
        let $obj = fbrCanvas.obj;
        if (!$obj || !$obj._activeObject) return;
        $obj.remove($obj._activeObject);
    },
    DeselectAll: function () {
        let $obj = fbrCanvas.obj;
        if (!$obj || !$obj._activeObject) return;
        $obj.discardActiveObject(null);
        $obj.renderAll();
    },
    ToggleOverlayOpacity: function (forceOpaque) {
        let $obj = fbrCanvas.obj;
        if (!$obj || !$obj.overlayImage) return;
        let state = forceOpaque === true || forceOpaque === false ? forceOpaque : obj.overlayImage.opacity = $obj.overlayImage.opacity === 1;
        let btnWrapper = $(".customization-controls");
        if (state) {
            $obj.overlayImage.opacity = 1;
            btnWrapper.find(".personalize-btn.personalize.--control-item").hide();
            btnWrapper.find(".personalize-btn.personalize.--control-general").show();
        } else {
            $obj.overlayImage.opacity = .25;
            btnWrapper.find(".personalize-btn.personalize.--control-item").show();
            btnWrapper.find(".personalize-btn.personalize.--control-general").hide();
        }

        let activeObj = $obj._activeObject;
        els.btnTriggerEdit().hide();
        if (!activeObj) {

        } else if (activeObj.type === 'text') {
            els.btnTriggerEdit().show();
        } else if (activeObj.type === 'image') {
        } else {

        }
    },
    UpdateDesignImage: async function () {
        if (!this.obj || !this.desinImgUrl) {
            return;
        }
        let get_image_url = 'https://w0w8ihsxlb.execute-api.ap-south-1.amazonaws.com/default/Myxt-Download-SignedUrl';
        let imageURL = `${get_image_url}?key=${atob(this.desinImgUrl)}&handle=${this.desinImgHandle}&source=web`;
        let imgData = await fetch(imageURL)
            .then((response) => response.json());
        fbrImage.AddDesignImage(imgData.data);
    }
};

const fileUploader = {
    _presignedURL: "https://6kvyc3ft0i.execute-api.ap-south-1.amazonaws.com/default/uploadImageUrl",
    upload: async function (file, fileName, timestamp) {
        const params = `?key=Prod/Orders/folder_${timestamp}/${fileName}`;
        let apiUrl = fileUploader._presignedURL + params;
        const signed_url = await fetchApiUrl(apiUrl);
        let result = await fileUploader.uploadFile(signed_url.url, file);
        console.info("Upload status : ", result);
        return signed_url.uploadedUrl;
    },
    uploadFile: async function (url, file) {
        let fileBlobData = fileUploader.convertToBlob(file, `image/${customizationFns.format}`);
        return new Promise((res, rej) => {
            var xhr = new XMLHttpRequest();
            xhr.open('PUT', url, true);
            xhr.onload = () => {
                if (xhr.status === 200) {
                    console.info('Uploaded data successfully');
                }
                res(xhr.status);
            };
            xhr.onerror = () => {
                console.error("file upload error : ", arguments);
                rej('Error');
            };
            xhr.send(fileBlobData);
        });
    },
    convertToBlob: (b64Data, contentType = "", sliceSize = 512) => {
        var startIndex = b64Data.indexOf("base64,") + 7;
        var b64 = b64Data.substr(startIndex);
        const byteCharacters = atob(b64);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    },
};

const utils = {
    getTimeStamp: function (makeNew = false) {
        if (makeNew || !els.hdnIndexId().val()) {
            const d = new Date();
            let output = "";
            output += `${d.getFullYear()}`;
            output += `${("0" + (parseInt(d.getMonth()) + 1)).slice(-2)}`;
            output += `${("0" + d.getDate()).slice(-2)}`;
            output += `${("0" + d.getHours()).slice(-2)}`;
            output += `${("0" + d.getMinutes()).slice(-2)}`;
            output += `${("0" + d.getSeconds()).slice(-2)}`;
            els.hdnIndexId().val(output);
        }
        return els.hdnIndexId().val();
    }, msWait: async function (ms) {
        return await new Promise(r => setTimeout(() => {
            r('');
        }, ms));
    }, downloadIMG: function (data, name, extension = "image/png") {
        var tag = document.createElement("a");
        tag.href = data;
        tag.download = name;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    }
};

const customizationFns = {
    _jsonURL: 'https://s3.ap-south-1.amazonaws.com/myxtur2.0/Prod/Additional-Files/custom_product_navigation.json',
    __keyTemplateURL: 'template_url',
    __keyOutputType: 'output_type',
    __keyCustomProductId: 'custom_product_id',
    __isSaveInProgress: false,
    fullJsonData: null,
    requiredJsonData: null,
    selectedData: {type: null, brand: null, model: null},
    height: null,
    width: null,
    ratio: null,
    ratioHW: null,
    conversationRatio: 1,
    finalHeight: null,
    finalWidth: null,
    format: 'jpg',
    GetSearchParamsFromQuery: function () {
        let params = location.search
            .slice(1).split("&").filter((x) => !!x)
            .map((z) => {
                let y = z.split("="), x = {};
                x[y[0]] = y[1];
                return x;
            })
            .reduce((c, p) => (p = {...p, ...c}), {});
        return params;
    },
    FetchData: async function () {

        let jsonData = null, type, brand, model, format, color;
        jsonData = await fetchApiUrl(customizationFns._jsonURL);
        customizationFns.fullJsonData = jsonData;
        const compareDelegate = (a, b) => a.toLowerCase().replace(/ /g, "_") === b.toLowerCase().replace(/ /g, "_");
        const checkAvailability = (item) => item && (!(item["availability"] === false));

        const params = customizationFns.GetSearchParamsFromQuery();
        if (params && params.type) {
            jsonData = jsonData.filter((x) => compareDelegate(x.title, params.type) && checkAvailability(x));
            if (!jsonData || !jsonData[0]) {
                alert("Item not available. Recirecting to Customization selection page");
                window.location = `${window.location.origin}/pages/customization-home`;
            }
            type = jsonData[0].title;

            customizationFns.selectedData.type = jsonData[0];
            jsonData = jsonData[0];

            if (jsonData[customizationFns.__keyOutputType]) {
                format = jsonData[customizationFns.__keyOutputType];
                customizationFns.format = format.toLowerCase();
            }

            if (jsonData[customizationFns.__keyCustomProductId]) {
                let variantURL = atob(jsonData[customizationFns.__keyCustomProductId]);
                let variantSplit = variantURL.split('/');
                els.hdnVariantId().val(variantSplit[variantSplit.length - 1]);
            }

        }

        if (params && params.brand) {
          jsonData = jsonData.items;
            jsonData = jsonData.filter((x) => compareDelegate(x.title, params.brand) && checkAvailability(x));
            if (!jsonData || !jsonData[0]) {
                alert("Item not available. Recirecting to Customization selection page");
                window.location = `${window.location.origin}/pages/customization-home`;
            }
            brand = jsonData[0].title;
            customizationFns.selectedData.brand = jsonData[0];

            jsonData = jsonData[0];

            if (jsonData[customizationFns.__keyOutputType]) {
                format = jsonData[customizationFns.__keyOutputType];
                customizationFns.format = format.toLowerCase();
            }

            if (jsonData[customizationFns.__keyCustomProductId]) {
                let variantURL = atob(jsonData[customizationFns.__keyCustomProductId]);
                let variantSplit = variantURL.split('/');
                els.hdnVariantId().val(variantSplit[variantSplit.length - 1]);
            }
        }
        if (params && params.model) {
            jsonData = jsonData.items;
            jsonData = jsonData.filter((x) => compareDelegate(x.title, params.model) && checkAvailability(x));
            if (!jsonData || !jsonData[0]) {
                alert("Item not available. Recirecting to Customization selection page");
                window.location = `${window.location.origin}/pages/customization-home`;
            }
            model = jsonData[0].title;
            customizationFns.selectedData.model = jsonData[0];
            jsonData = jsonData[0];
            if (jsonData[customizationFns.__keyCustomProductId]) {
                let variantURL = atob(jsonData[customizationFns.__keyCustomProductId]);
                let variantSplit = variantURL.split('/');
                els.hdnVariantId().val(variantSplit[variantSplit.length - 1]);
            }
        }
        if (params && params.key) {
            jsonData['key'] = params.key;
        }

        if (params && params.key) {
            jsonData['handle'] = params.handle;
        }

        if (params && params.color) {
            jsonData = jsonData.items.filter((x) => compareDelegate(x.title, params.color) && checkAvailability(x));
            jsonData = jsonData[0];
            color = params.color;
        }

        customizationFns.requiredJsonData = jsonData || {};
        customizationFns.requiredJsonData.type = type;
        customizationFns.requiredJsonData.brand = brand;
        customizationFns.requiredJsonData.model = model;
        customizationFns.requiredJsonData.format = format;
        customizationFns.requiredJsonData.color = color;
        return jsonData;
    },
    GetImagDetails: async function (imageURL) {
        if (!imageURL) {
            throw "Image url is empty";
        }

        return new Promise((resolve, reject) => {
            let img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => customizationFns.imageNotFound(imageURL);
            img.src = imageURL;
        });
    },
    imageNotFound: function (imageURL) {
        const error_log_url = "https://advma4hpvk.execute-api.ap-south-1.amazonaws.com/default/Myxtur-FinalDesignTemplateErrors";

        fetch(error_log_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                key: imageURL,
                message: "Template image not available",
                handle: imageURL,
                source: "WEB"
            }),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to log error. Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                console.log(data);
            })
            .catch(error => {
                console.log(error);
            });

        alert("Template image not available. Redirecting for selection.");
        window.location = `${window.location.origin}/pages/customization-home`;
    },
    Init: async function () {
        utils.getTimeStamp(true);
        let data = await customizationFns.FetchData();
        console.log(data);
        els.hdnType().val(data.type);
        els.hdnMake().val(data.brand);
        els.hdnModel().val(data.model);
        fbrCanvas.maskURL = data[customizationFns.__keyTemplateURL];
        fbrCanvas.desinImgUrl = data['key'];
        fbrCanvas.desinImgHandle = data['handle'];
        let imgDetails = await customizationFns.GetImagDetails(fbrCanvas.maskURL);
        customizationFns.finalHeight = imgDetails.height;
        customizationFns.finalWidth = imgDetails.width;
        customizationFns.height = imgDetails.height;
        customizationFns.width = imgDetails.width;
        customizationFns.ratio = customizationFns.finalWidth / customizationFns.finalHeight;
        customizationFns.ratioHW = customizationFns.finalHeight / customizationFns.finalWidth;
        els.btnTriggerSave().on('click', (e) => {
            customizationFns.Save(e);
        });
    },
    Save: async function () {
        if (customizationFns.__isSaveInProgress) return;
        customizationFns.__isSaveInProgress = true;
        pageLoader.toggle('Processing', true);
        pageLoader.clearLog();
        pageLoader.log('Initializing', 2);

        let uploaded_files = "";

        const timeStamp = utils.getTimeStamp(true);

        pageLoader.log('Uploading images', 0);
        let croppedImageURL = await customizationFns.GetCroppedImageURL(timeStamp);
        uploaded_files += croppedImageURL.url;
        els.hdnImageCropped().val(croppedImageURL.url);
        pageLoader.log('Uploaded images completed', 2, true);

        pageLoader.log('Uploading original images', 0);
        let originalFiles = customizationFns.GetOriginalFilesList();
        for (let i = 0; i < originalFiles.length; i++) {
            let org_img = await fileUploader.upload(originalFiles[i], `${timeStamp}_${i}`, timeStamp);
            uploaded_files += org_img;
        }
        pageLoader.log('Uploaded original images', 2, true);

        pageLoader.log('Uploading preview images', 0);

        let displayImageURL = await customizationFns.GetDisplayImageURL(timeStamp);
        uploaded_files += displayImageURL.url;
        // els.hdnImagePreview().val(displayImageURL.url);
        els.hdnImage().val(displayImageURL.url);
        pageLoader.log('Uploaded preview images', 2, true);

        console.log("App - uploaded files ;", timeStamp);

        pageLoader.log('Processing completed... ', 2);
        pageLoader.log('Proceeding to cart ', 0);
        await utils.msWait(500);
        customizationFns.__isSaveInProgress = false;
        els.elForm().submit();
    },
    GetOriginalFilesList: function () {
        if (!fbrCanvas || !fbrCanvas.obj) {
            return;
        }
        const $obj = fbrCanvas.obj;

        let images = [];
        for (let item of $obj._objects) {
            if (!item.hasOwnProperty("_element")) continue;
            images.push(item._element.src);
        }
        return images;
    },
    GetCroppedImageURL: async function (timeStamp = null) {
        if (!fbrCanvas || !fbrCanvas.obj) {
            return;
        }

        const $obj = fbrCanvas.obj;
        if (!!$obj && !!$obj.overlayImage) {
            $obj.overlayImage.opacity = 0;
        }
        const scaleFactor = (customizationFns.conversationRatio || 1) / window.devicePixelRatio;
        const data = $obj.toDataURL({
            format: customizationFns.format, multiplier: scaleFactor, enableRetinaScaling: true
        });
        let urlData = await fileUploader.upload(data, `cropped_${timeStamp}.${customizationFns.format}`, timeStamp);

        if (!!$obj && !!$obj.overlayImage) {
            $obj.overlayImage.opacity = 1;
        }
        return {url: urlData, data: data};
    },
    GetDisplayImageURL: async function (timeStamp = null) {
        if (!fbrCanvas || !fbrCanvas.obj) {
            return;
        }

        const $obj = fbrCanvas.obj;
        if (!!$obj && !!$obj.overlayImage) {
            $obj.overlayImage.opacity = 1;
        }

        const data = $obj.toDataURL({format: customizationFns.format, multiplier: 1, enableRetinaScaling: true});
        let urlData = await fileUploader.upload(data, `display_${timeStamp}.jpg`, timeStamp);

        return {url: urlData, data: data};
    }
};

const googleAdsForCustomization = {
    __schema: {
        page_type: 'product', event: 'view_item', data: {
            total_price: 0, shop_currency: 'INR', product_data: []
        }
    },
    __schemaProduct: {
        "variant_id": -1,
        "product_id": -1,
        "name": "Title of the Product",
        "price": "0",
        "currency": "INR",
        "sku": "",
        "brand": "Myxtur",
        "variant": "",
        "category": ""
    },
    getSchema: () => JSON.parse(JSON.stringify(googleAdsForCustomization.__schema)),
    getProductSchema: () => JSON.parse(JSON.stringify(googleAdsForCustomization.__schemaProduct)),
    Init: function () {
        const data = customizationFns.selectedData;
        const type = data && data.type || {};
        const brand = data && data.brand || {};
        const model = data && data.model || {};

        let variantURL = atob(type.custom_product_id || '');
        let variantSplit = variantURL.split('/');

        let gfsProduct = googleAdsForCustomization.getProductSchema();
        gfsProduct.variant_id = variantSplit[variantSplit.length - 1];
        gfsProduct.product_id = atob(type.product_id || '');
        gfsProduct.name = type.title;
        gfsProduct.price = type.price;
        gfsProduct.brand = type.brand;
        gfsProduct.category = type.category;
        gfsProduct.variant = (brand && brand.title || '') + " " + (model && model.title || '');
        let gfsConversationData = googleAdsForCustomization.getSchema();
        gfsConversationData.data.total_price = type.price;
        gfsConversationData.data.product_data.push(gfsProduct);

        window.gsf_conversion_data = gfsConversationData;
    }
};

const pageLoader = {
    id: 'page-loader',
    hideCls: 'hide-below',
    spinnerContainerCls: '.page-loader-spinner-wrapper',
    spinnerTextCls: '.spinner-text',
    logContainerCls: '.page-processing-messages',
    container: () => $('#' + pageLoader.id),
    spinnerContainer: () => pageLoader.container().find(pageLoader.spinnerContainerCls),
    spinnerTextContainer: () => pageLoader.spinnerContainer().find(pageLoader.spinnerTextCls),
    logContainer: () => pageLoader.container().find(pageLoader.logContainerCls),
    toggle: function (text = "Loading", forceState = null) {

        pageLoader.spinnerTextContainer().text(text);

        if (forceState === true) {
            pageLoader.container().addClass(pageLoader.hideCls);
            pageLoader.spinnerContainer().show();
        } else if (forceState === false) {
            pageLoader.container().removeClass(pageLoader.hideCls);
            pageLoader.spinnerContainer().hide();
        } else {
            pageLoader.container().toggleClass(pageLoader.hideCls);
            pageLoader.spinnerContainer().toggle();
        }
    },
    hideLog: () => pageLoader.logContainer().hide(),
    clearLog: () => pageLoader.logContainer().html(''),
    log: (text, type, isUpdate = false) => {
        pageLoader.logContainer().show();
        let htmlCode = '<div class="page-processing-messages-item">';
        htmlCode += `<span class="page-processing-messages-item-icon">${type == 0 ? 'O' : (type == 1 ? 'X' : '✓')}</span>`;
        htmlCode += `<span class="page-processing-messages-item-text">${text}</span>`;
        htmlCode += '</div>';
        if (isUpdate) {
            pageLoader.logContainer().children().last().remove();
        }
        pageLoader.logContainer().append(htmlCode);

    },
};

const page = {
    ratio: 1,
    toOriginalRatio: 1,
    height: null,
    width: null,
    usableWidth: null,
    usableHeight: null,
    InitializePage: function () {
        const totalHeight = window.innerHeight;
        const buttonPaddingHeight = Math.min(Math.max(totalHeight * .25, 250), 300);
        page.height = totalHeight - buttonPaddingHeight; //433.33; //window.innerHeight - 100;
        page.height = page.height - (page.height % 10);
        page.ratio = customizationFns.ratio;
        page.width = page.height * page.ratio; // window.innerWidth - 100;
        if (page.width > (window.innerWidth - (window.innerWidth * .2))) {
            page.width = window.innerWidth * .8;
            page.height = page.width * customizationFns.ratioHW;
        }
        page.ratio = page.width / page.height;

        page.toOriginalRatio = 3900 / page.height;
        customizationFns.conversationRatio = customizationFns.finalHeight / page.height;
        document.querySelector(':root').style.setProperty('--container-width', page.width + "px");
    },
    InitializePageEvents: function () {
        fbrImage.InitializeEvents();
        fbrText.InitializeEvents();
        fbrBackgroundColor.InitializeEvents();
    },
    init: async function () {
        pageLoader.clearLog();
        pageLoader.hideLog();
        pageLoader.toggle('Loading', true);
        const d = await customizationFns.Init();
        page.InitializePage();
        page.InitializePageEvents();
        fbrCanvas.Init();
        pageLoader.toggle('Loading', false);
        googleAdsForCustomization.Init();
        document.addEventListener("click", (e) => {
            if (e.target.nodeName != "CANVAS") fbrCanvas.DeselectAll();
        });
    }
};

page.init();
